import { render, staticRenderFns } from "./StepOptionRadio.vue?vue&type=template&id=52093960&scoped=true&"
import script from "./StepOptionRadio.vue?vue&type=script&lang=ts&"
export * from "./StepOptionRadio.vue?vue&type=script&lang=ts&"
import style0 from "./StepOptionRadio.vue?vue&type=style&index=0&id=52093960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52093960",
  null
  
)

export default component.exports